<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xfztE6/images/cover.jpg?1684979252503" alt="This image is the cover for the book Sacred Misinterpretation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sacred Misinterpretation
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Promotes gracious interfaith dialogue on sensitive theological issues</i></p><p>Theological issues are crucial to how Christians and Muslims understand and perceive each other. In <i>Sacred Misinterpretation </i>Martin Accad guides readers through key theological questions that fuel conflict and misunderstanding between Muslims and Christians. A sure-footed guide, he weaves personal stories together with deep discussion of theological beliefs.</p>Accad identifies trends, recognizes historical realities, and brings to light significant points of contention that often lead to break-down in Christian-Muslim dialogue. He also outlines positive and creative trends that could lead to a more hopeful future. Fairly and seriously presenting both Muslim theology and a Muslim interpretation of Christian theology, <i>Sacred Misinterpretation </i>is an essential guide for fostering dialogue and understanding among readers from both faiths.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin Accad, Gabriel Said Reynolds
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d8a2e3fe